import { render, staticRenderFns } from "./RemanentGraph.vue?vue&type=template&id=5cbbdfa1"
import script from "./RemanentGraph.vue?vue&type=script&lang=js"
export * from "./RemanentGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports